module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "selectFluxer",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [(!_vm.isEspontaneo) ? _c('md-dialog-title', [_vm._v("Pedir feedback a un compañero")]) : _vm._e(), _vm._v(" "), (_vm.isEspontaneo) ? _c('md-dialog-title', [_vm._v("Dar feedback espontaneo")]) : _vm._e(), _vm._v(" "), _c('md-dialog-content', [_c('autocomplete', {
    attrs: {
      "label": 'Busca al fluxer aqui',
      "array": _vm.allFluxers,
      "debounce": 1000
    },
    model: {
      value: (_vm.fluxerSelected),
      callback: function($$v) {
        _vm.fluxerSelected = $$v
      },
      expression: "fluxerSelected"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "md-error"
  }, [_vm._v("El fluxer seleccionado es incorrecto")])], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.onOkSelectFluxer('cancel', 'selectFluxer')
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.onOkSelectFluxer('ok', 'selectFluxer')
      }
    }
  }, [_vm._v("aceptar")])], 1), _vm._v(" "), _c('md-snackbar', {
    ref: "toastFluxer",
    attrs: {
      "md-position": 'bottom center',
      "md-duration": 4000
    },
    on: {
      "close": function($event) {
        _vm.clearInput()
      }
    }
  }, [(!_vm.isEspontaneo) ? _c('span', [_vm._v("El feedback se pidio correctamente a: " + _vm._s(_vm.fluxerSelected) + " ")]) : _vm._e(), _vm._v(" "), (_vm.isEspontaneo) ? _c('span', [_vm._v("El feedback espontaneo a: " + _vm._s(_vm.fluxerSelected) + " se creo correctamente ")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0988bca5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeedbackCompanion.vue
// module id = 367
// module chunks = 1